import { Component, OnInit, OnDestroy } from "@angular/core";
import { LocalService, StoreService } from "../../services";
import { Subscription } from "rxjs";
import { isPamUser, isProfileComplete } from 'src/app/shared/utils/user.util';

@Component({
  selector: "cisco-steer-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, OnDestroy {
  userData: any;
  notificationFlag: boolean = false;
  welcomeModalOpen: boolean = false;

  private userSubscription: Subscription | null = null;
  private updateRoleSubscription: Subscription | null = null;

  constructor(private storeService: StoreService) { }

  ngOnInit(): void {
    this.loadUserData();
    this.refreshFromCache();

    this.updateRoleSubscription = this.storeService.updateRole.subscribe((roleUpdated: boolean) => {
      if (roleUpdated) {
        this.refreshFromCache();
      }
    });
  }

  private loadUserData(): void {
    this.userSubscription = this.storeService.getUserObj().subscribe((res: any) => {
      if (res !== null) {
        this.userData = res;
        this.notificationFlag = isProfileComplete(res);

        if (isPamUser(res)) {
          this.openWelcomeDialog();
        }
      }
    });
  }

  private refreshFromCache(): void {
    this.userData = LocalService.get("userProfile");
    if (isProfileComplete(this.userData)) {
      this.notificationFlag = true;
    }
  }

  get isPamUserActive(): boolean {
    return isPamUser(this.userData);
  }

  private openWelcomeDialog(): void {
    this.welcomeModalOpen = true;
  }

  closeWelcomeModal(): void {
    this.welcomeModalOpen = false;
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    if (this.updateRoleSubscription) {
      this.updateRoleSubscription.unsubscribe();
    }
  }
}
